import { makeStyles } from "@material-ui/core";
import { Drawer } from "@material-ui/core";
import React, { Fragment } from "react";
import { NavLink } from "react-router-dom";
import menu from "../menu";

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: "220px",
    height: "100%",
    backgroundColor: "black",
    color: "white",
  },
  navbar: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    marginLeft: 15,
    marginTop: 150,
  },
  navItem: {
    margin: "10px 0px",
    width: "100%",
    color: "white",
    textTransform: "capitalize",
    fontSize: "16px",
    fontWeight: "200",
    letterSpacing: "1",
    textDecoration: "none",
  },
  activeNav: {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
}));

function Sidebar(props) {
  const classes = useStyles();
  const { open, onClose, variant } = props;
  return (
    <Fragment>
      <Drawer
        classes={{ paper: classes.drawer }}
        anchor="left"
        open={open}
        variant={variant}
        onClose={onClose}
      >
        <div className={classes.navbar}>
          {menu.map((item) => (
            <NavLink
              className={classes.navItem}
              to={item.path}
              activeClassName={classes.activeNav}
            >
              {item.title}
            </NavLink>
          ))}
        </div>
      </Drawer>
    </Fragment>
  );
}

export default Sidebar;
